export enum Loglevel {
    ERROR = 'ERROR',
    WARNING = 'WARN',
    INFO = 'INFO',
    DEBUG = 'DEBUG'
}